<a
  href="https://starliteindonesia.com"
  target="_blank"
  style="text-decoration: none"
>
  <div class="container-fluid starlite-wrapper">
    <div class="starlite">
      <div>
        <p class="mb-0 me-2">Nikmati internet cepat & terjangkau bersama</p>
        <img src="assets/img/starlite_logo.svg" />
      </div>
      <div>
        <div class="package-wrapper">
          <div>
            <div class="package p250">
              <img src="assets/img/icon_lightning.svg" />
              <div>
                <strong>500 Mbps</strong> hanya <strong>250rb</strong>/ bulan
              </div>
            </div>
            <p>atau</p>
            <div class="package p100">
              <img src="assets/img/icon_thumb_up.svg" />
              <div>
                <strong>200 Mbps</strong> hanya <strong>100rb</strong>/ bulan
              </div>
            </div>
          </div>
          <i class="fa fa-arrow-right"></i>
        </div>
        <div class="package p250">
          <img src="assets/img/icon_lightning.svg" />
          <div>
            <strong>500 Mbps</strong> hanya <strong>250rb</strong>/ bulan
          </div>
        </div>
        <p class="d-none d-md-block">atau</p>
        <div class="package p100">
          <img src="assets/img/icon_thumb_up.svg" />
          <div>
            <strong>200 Mbps</strong> hanya <strong>100rb</strong>/ bulan
          </div>
        </div>
      </div>
    </div>
    <i class="fa fa-arrow-right d-none d-md-block"></i>
  </div>
</a>
<nav class="navbar navbar-expand-lg {{ style }}">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="">
      <img src="assets/img/weave-image.png" />
    </a>
    <div class="header-right-menu">
      <app-lang-select class="mobile-show"></app-lang-select>
      <button
        class="navbar-toggler collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarHeader"
        aria-controls="navbarHeader"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="custom-toggler-icon top"></span>
        <span class="custom-toggler-icon mid"></span>
        <span class="custom-toggler-icon bot"></span>
      </button>
    </div>

    <div class="navbar-collapse collapse" id="navbarHeader">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item dropdown">
          <a class="nav-link" routerLink="/company">{{
            "GLOBAL.COMPANY.ABOUT_US" | translate
          }}</a>
          <!-- <a class="nav-link dropdown-toggle" href="#" id="navHeadCompany"
            data-bs-toggle="dropdown" aria-expanded="false">&nbsp;</a> -->
          <button
            type="button"
            class="btn dropdown-toggle"
            id="navHeadCompany"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul class="dropdown-menu" aria-labelledby="navHeadCompany">
            <li>
              <a class="dropdown-item" routerLink="/company/vision_mission">{{
                "GLOBAL.COMPANY.VISION_MISSION" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/company/history">{{
                "GLOBAL.COMPANY.HISTORY" | translate
              }}</a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/company/company_structure"
                >{{ "GLOBAL.COMPANY.COMPANY_STRUCTURE" | translate }}</a
              >
            </li>
            <li>
              <a class="dropdown-item" routerLink="/company/management">{{
                "GLOBAL.COMPANY.MANAGEMENT" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/company/company_profile">{{
                "GLOBAL.COMPANY.COMPANY_PROFILE" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/company/financial_report">{{
                "GLOBAL.COMPANY.FINANCIAL_REPORT" | translate
              }}</a>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link" routerLink="/product">{{
            "GLOBAL.PRODUCT_SERVICES.PRODUCT_SERVICES" | translate
          }}</a>
          <!-- <a class="nav-link dropdown-toggle" href="#" id="navHeadProduct"
            data-bs-toggle="dropdown" aria-expanded="false">Product & Services</a> -->
          <button
            type="button"
            class="btn dropdown-toggle"
            id="navHeadProduct"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul class="dropdown-menu" aria-labelledby="navHeadProduct">
            <li>
              <a class="dropdown-item" routerLink="/product/leased_core">{{
                "GLOBAL.PRODUCT_SERVICES.LEASED_CORE" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/product/leased_line">{{
                "GLOBAL.PRODUCT_SERVICES.LEASED_LINE" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/product/colocation">{{
                "GLOBAL.PRODUCT_SERVICES.COLOCATION" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/product/cdn">{{
                "GLOBAL.PRODUCT_SERVICES.CDN" | translate
              }}</a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/product/tower_fiberization"
                >{{
                  "GLOBAL.PRODUCT_SERVICES.TOWER_FIBERIZATION" | translate
                }}</a
              >
            </li>
            <!-- <li><a class="dropdown-item" routerLink="/product/ip_transit">{{ 'GLOBAL.PRODUCT_SERVICES.IP_TRANSIT' | translate }}</a></li> -->
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link" routerLink="/coverage">{{
            "GLOBAL.COVERAGE.COVERAGE" | translate
          }}</a>
          <!-- <a class="nav-link dropdown-toggle" href="#" id="navHeadCoverage"
            data-bs-toggle="dropdown" aria-expanded="false">Coverage</a> -->
          <button
            type="button"
            class="btn dropdown-toggle"
            id="navHeadCoverage"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul class="dropdown-menu" aria-labelledby="navHeadCoverage">
            <li>
              <a class="dropdown-item" routerLink="/coverage/backbone">{{
                "GLOBAL.COVERAGE.JAVA_BACKBONE" | translate
              }}</a>
            </li>
            <!-- <li><a class="dropdown-item" href="#">Check Availability Network</a></li> -->
            <!-- <li>
              <a class="dropdown-item" routerLink="/coverage/order_form">{{
                "GLOBAL.COVERAGE.ORDER_FORM" | translate
              }}</a>
            </li> -->
            <!-- <li><a class="dropdown-item" href="#">Network Monitoring Tools</a></li> -->
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link" routerLink="/news">{{
            "GLOBAL.NEWS.NEWS" | translate
          }}</a>
          <!-- <a class="nav-link dropdown-toggle" href="#" id="navHeadNews"
            data-bs-toggle="dropdown" aria-expanded="false">News</a> -->
          <button
            type="button"
            class="btn dropdown-toggle"
            id="navHeadNews"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul class="dropdown-menu" aria-labelledby="navHeadNews">
            <li>
              <a class="dropdown-item" routerLink="/news">{{
                "GLOBAL.NEWS.PRESS_RELEASE" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/news">{{
                "GLOBAL.NEWS.PROMOTION" | translate
              }}</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/news">{{
                "GLOBAL.NEWS.CAREER" | translate
              }}</a>
            </li>
          </ul>
        </li>
        <!-- <li class="nav-item dropdown">
          <a class="nav-link" routerLink="/support">Support</a>
          <a class="nav-link dropdown-toggle" href="#" id="navHeadSupport"
            data-bs-toggle="dropdown" aria-expanded="false">Support</a>
          <button type="button" class="btn dropdown-toggle" id="navHeadSupport"
            data-bs-toggle="dropdown" aria-expanded="false"></button>
          <ul class="dropdown-menu" aria-labelledby="navHeadSupport">
            <li><a class="dropdown-item" href="#">Customer Portal</a></li>
            <li><a class="dropdown-item" href="#">How To</a></li>
          </ul>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/contact-us">{{
            "CONTACT.CONTACT" | translate | titlecase
          }}</a>
        </li>
      </ul>
      <div class="header-right-menu">
        <app-lang-select class="mobile-hide"></app-lang-select>
        <a routerLink="/contact-us" class="talk">
          {{ "GLOBAL.LETS_TALK" | translate }}
          <div class="icon-talk">
            <div class="semi-circle"></div>
          </div>
        </a>
      </div>
    </div>
  </div>
</nav>
